import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { AdItem } from '@sbt-web/network/types';
import { AdItemCardMini } from '@sbt-web/item-card';
import { useTrackImpression } from '@/tools/tracking/useTrackImpression';
export type Props = {
  item: AdItem;
  onClick?: () => void;
  lazyLoad?: boolean;
  onImpression: () => void;
};
export const RecommenderCard = t0 => {
  const $ = _c(9);
  const {
    item,
    onClick,
    lazyLoad,
    onImpression
  } = t0;
  const componentRef = useRef(null);
  let t1;
  if ($[0] !== onImpression) {
    t1 = {
      enabled: true,
      track: onImpression
    };
    $[0] = onImpression;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const setComponentRef = useTrackImpression(t1);
  let t2;
  let t3;
  if ($[2] !== setComponentRef) {
    t2 = () => {
      if (componentRef?.current) {
        setComponentRef(componentRef.current);
      }
    };
    t3 = [setComponentRef, componentRef];
    $[2] = setComponentRef;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== item || $[6] !== lazyLoad || $[7] !== onClick) {
    t4 = <AdItemCardMini ref={componentRef} assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} key={item.urn} item={item} onClick={onClick} aspectRatio="4/5" imageSizeType="responsive" lazyLoad={lazyLoad} />;
    $[5] = item;
    $[6] = lazyLoad;
    $[7] = onClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};